/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from 'react'
import { Link, Outlet, Route, Routes } from 'react-router-dom'
import { Registration } from './components/Registration'
import { ForgotPassword } from './components/ForgotPassword'
import { Login } from './components/Login'
import { toAbsoluteUrl } from '../../../_metronic/helpers'

const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-start bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      style={{
        backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/amber-bg1.jpg')})`,
      }}
    >
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        {/* begin::Logo */}
        <Link to='/' className='mb-12'>
          <img alt='Amber Bills' title='Amber Bills' src={toAbsoluteUrl('/media/logos/logo1.png')} className='h-60px' />
        </Link>
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className='w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto'>
          <Outlet />
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      <div className='d-flex flex-center flex-column-auto p-10'>
        <div className='d-flex align-items-center fw-bold fs-6'>
          <a href='https://www.amberinfotech.com/about-us' target="_blank" className='text-muted text-hover-primary px-2'>
            About
          </a>
        &nbsp;|&nbsp;
          <a href='https://amberinfotech.com/contact-us' target="_blank" className='text-muted text-hover-primary px-2'>
            Contact Us
          </a>
          &nbsp;|&nbsp;
          <a href='#' className='text-muted text-hover-primary px-2'>
            Version: {process.env.REACT_APP_VERSION}
          </a>
        </div>
      </div>
      {/* end::Footer */}
    </div>
  )
}

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='registration' element={<Registration />} />
      <Route path='registration/:email' element={<Registration />} />
      {/* <Route path='onboarding-steps/:userKey' element={<RegistrationSteps />} /> */}
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export { AuthPage }
